import Cookies from "js-cookie";

export function redirectUser() {
  const baseUrl = `${location.protocol}//${location.host}`;
  const { next } = window.context || {};

  if (next) {
    location.replace(`${baseUrl}/${next}`);
  } else {
    location.replace(`${baseUrl}/app`);
  }
}

export function setCookies(obj = {}) {
  const cookieOptions = {
    path: "/",
    expires: 90,
  };

  Object.entries(obj).forEach(([key, value]) => {
    Cookies.set(key, value, cookieOptions);
  });
}

export function getOrgOrGeneralUrl(orgIdentifier, path) {
  return orgIdentifier ? `/org/${orgIdentifier}/${path || ""}` : `/${path || ""}`;
}
